import { Component, HostListener } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDrawerMode, MatSidenavModule } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';
import { MenuComponent } from '../menu/menu.component';
import { HeaderComponent } from '../header/header.component';
import { LoadingComponent } from "../loading/loading.component";
import { IdleComponent } from "../idle/idle.component";
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-dashboard',
    standalone: true,
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.css',
    imports: [MatButtonModule, MatSidenavModule, RouterOutlet, MenuComponent, HeaderComponent, LoadingComponent, IdleComponent, MatIconModule]
})
export class DashboardComponent {
  modeMenu: MatDrawerMode = 'side';
  open: boolean = true;

  @HostListener('window:resize', ['$event.target.innerWidth'])
  changeMode(width: any) {
    if (width < 992) {
      this.modeMenu = 'over';
      this.open = false;
    } else {
      this.modeMenu = 'side';
      this.open = true;
    }
  }

  ngOnInit () {
    this.changeMode(window.innerWidth);
  }
}
